/**
 * hitsihuomio.ts — hitsin huomio näyttöön (T675, Toni 31.10.2026 klo 11.00 kohta 5).
 *
 * `hitsi.huomiot` kantaa mastertuonnin liitostiedon ja masterin Notes-tekstin samassa kentässä erottimella « · »
 * («Liitos: BW · Korjattu lomakkeen mukaan»). Liitos on jo omassa sarakkeessaan (`hitsi.liitos`, 120), joten se ei saa peittää
 * varsinaista huomiota: «Liitos: …» -osat jätetään pois, ja tyhjä tulos on null (ei näytetä mitään).
 * Mitattu pekilo 27.10.2026: huomio 11 297 hitsillä, joista «Liitos:»-alkuisia 6 991 ja Notes mukana 2 564.
 */
export function hitsinHuomio(huomiot: string | null | undefined): string | null {
  if (!huomiot) return null;
  const osat = huomiot.split(/\s+·\s+/).map((x) => x.trim()).filter((x) => x && !/^liitos:/i.test(x));
  return osat.length ? osat.join(" · ") : null;
}
